const SET_PRELOADER = "SET_PRELOADER";

export default {
  namespaced: true,

  state: {
    preloader: false
  },

  actions: {
    changePreloader({ commit }, payload) {
      commit(SET_PRELOADER, payload);
    }
  },

  mutations: {
    [SET_PRELOADER](state, payload) {
      state.preloader = payload;
    }
  },

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/preloader.js